<template>
    <div class="brt-filter-item-module" :style="itemStyles">
        <div class="brt-fi-label" :style="labelStyles">
            <span v-if="label">{{ label }}</span>
            <slot v-else name="label"></slot>
        </div>

        <div class="brt-fi-content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "FilterBoxItem",

        computed: {
            itemStyles () {
                let style = {};
                if(this.filterBox.inline === '') {
                    const spacing = this.itemRight === 0 || this.itemRight ? this.itemRight : this.filterBox.itemRight;
                    if (spacing || spacing === 0) {
                        style.marginRight = `${spacing}px`;
                    }
                }
                return style;
            },
            labelStyles () {

                let style = {};
                if(this.filterBox.inline === undefined) {
                    const labelWidth = this.labelWidth === 0 || this.labelWidth ? this.labelWidth : this.filterBox.labelWidth;
                    if (labelWidth || labelWidth === 0) {
                        style.width = `${labelWidth}px`;
                        style.textAlign = 'right';
                    }
                }

                if (!this.label) {
                    style.marginRight = '0';
                }

                return style;
            }

        },
        inject: ['filterBox'],
        props: {
            label: {
                default: ''
            },
            itemRight: {
                type: Number
            },
            labelWidth: {
                type: Number
            }
        }
    }
</script>

<style lang="less">
    @import "../../styles/comm.less";

    .brt-filter-item-module {

        > div {
            display: inline-block;
            vertical-align: top;
        }

        > .brt-fi-label {
            line-height: 32px;
            margin-right: 10px;
            color: @FontColorA2;
        }

    }

</style>
